import { AUTH_CONFIG } from '../config';

export class AuthSessionStorage {
	get authToken() {
		return sessionStorage.getItem(AUTH_CONFIG.AUTH_TOKEN_KEY);
	}

	get authUser() {
		return JSON.parse(sessionStorage.getItem(AUTH_CONFIG.AUTH_USER_KEY));
	}

	setAuthDetails = (user, token) => {
		sessionStorage.setItem(AUTH_CONFIG.AUTH_TOKEN_KEY, token);
		sessionStorage.setItem(AUTH_CONFIG.AUTH_USER_KEY, JSON.stringify(user));
	}

	deleteAuthDetails = () => {
		sessionStorage.clear();
	}
}